import React from 'react';
import type { FC } from 'react';
import { RATING_HINT_TEXT } from '@alfa-bank/site-invest-mediaportal-common/constants';

import { useEmitentsDetailPageDataContext } from '../../components/data-provider/context';
import { dataTestIds } from '../../configs';

import type { TInvestMediaportalEmitentsDetailPageAssetRating } from './models';

export const AssetRatingContainer: FC<TInvestMediaportalEmitentsDetailPageAssetRating> = ({
    AssetRating,
    hintLink,
    ratingTitle,
    tooltipText = RATING_HINT_TEXT,
}) => {
    const { asset } = useEmitentsDetailPageDataContext();

    if (!asset) {
        return null;
    }

    return (
        <section data-test-id={dataTestIds.assetRatingContainer}>
            <AssetRating
                dataTestId={dataTestIds.assetRating}
                hintLink={hintLink}
                scores={asset.decomposedRating?.scores || []}
                title={ratingTitle}
                tooltipText={tooltipText}
            />
        </section>
    );
};
